import React, { useState } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({
  apidata = [],
  columns = [],
  searchBy = "name",
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [dataFilter, setDataFilter] = useState("");
  const [applicableToFilter, setApplicableToFilter] = useState("");

  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setDataFilter("");
    setApplicableToFilter("");
    setShowFilterModal(false);
  };

  // Filter data locally
  const filteredData = apidata.filter((row) => {
    // Search filter
    const searchValue = dataFilter.trim().toLowerCase();

    const matchesSearch =
      !searchValue ||
      row[searchBy]?.toString().toLowerCase().includes(searchValue);

    // Applicable To filter
    const matchesApplicableTo =
      !applicableToFilter ||
      (Array.isArray(row.applicableTo) &&
        row.applicableTo.includes(applicableToFilter));

    return matchesSearch && matchesApplicableTo;
  });

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        {/* Search */}
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>

        {/* Filter button */}
        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        fixedHeader
        highlightOnHover
        responsive
      />

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applicableToFilter={applicableToFilter}
        setApplicableToFilter={setApplicableToFilter}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
      />
    </div>
  );
}
